"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DiagramPrevious: function() {
        return DiagramPrevious;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const DiagramPrevious = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1 20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V16C23 14.8954 22.1046 14 21 14H13V9.41421L13.2929 9.70711C13.6834 10.0976 14.3166 10.0976 14.7071 9.70711C15.0976 9.31658 15.0976 8.68342 14.7071 8.29289L12.7071 6.29289C12.3166 5.90237 11.6834 5.90237 11.2929 6.29289L9.29289 8.29289C8.90237 8.68342 8.90237 9.31658 9.29289 9.70711C9.68342 10.0976 10.3166 10.0976 10.7071 9.70711L11 9.41421V14H3C1.89543 14 1 14.8954 1 16V20ZM12 16H21V20H3V16H12ZM1 8C1 9.10457 1.89543 10 3 10H6C6.55228 10 7 9.55229 7 9C7 8.44771 6.55228 8 6 8H3V4H21V8H18C17.4477 8 17 8.44771 17 9C17 9.55229 17.4477 10 18 10H21C22.1046 10 23 9.10457 23 8V4C23 2.89543 22.1046 2 21 2H3C1.89543 2 1 2.89543 1 4V8Z",
        fill: "currentColor"
    })
}), "DiagramPrevious");
const _default = DiagramPrevious;
